// @flow
import React from 'react';
// Styles
import './ProductContentSkeleton.css';

const ProductContentSkeleton = ({ withOptions, withFatLevel }) => {
  return (
    <div className="product-page-main">
      <div className="main-product-container">
        <div className={`image-gallery`}>
          <div className={`image-gallery-main skeleton-block`}>
          </div>
        </div>
        <div className="buy-box-main buy-box-main--skeleton">
          {/* Title */}
          <div className="buy-box-title">
            <div className="skeleton-block buy-box-skeleton-manufacturer" />
            <div className="skeleton-block buy-box-skeleton-product-name" />
            <div className="skeleton-block buy-box-skeleton-storage" />
          </div>

          <section className="buy-box-section">
            {/* Options */}
            <div className="buy-box-skeleton-info-cards">
              <div className="skeleton-block buy-box-skeleton-option buy-box-skeleton-option--short" />
              <div className="skeleton-block buy-box-skeleton-option buy-box-skeleton-option--short" />
              <div className="skeleton-block buy-box-skeleton-option buy-box-skeleton-option--short" />
            </div>

            {/* Info cards */}
            <div className="buy-box-skeleton-info-cards">
              <div className="skeleton-block buy-box-skeleton-info-card" />
              <div className="skeleton-block buy-box-skeleton-info-card" />
              <div className="skeleton-block buy-box-skeleton-info-card" />
              <div className="skeleton-block buy-box-skeleton-info-card" />
            </div>

            {/* Price + Add to cart */}
            <div className="buy-box-section-price-container">
              <div className="skeleton-block buy-box-skeleton-button" />
              <div className="skeleton-block buy-box-skeleton-price" />
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ProductContentSkeleton;
